/**
 * Powered by Cerebro Core Badge
 * This badge must always be visible on tenant-facing pages.
 * It cannot be disabled or hidden by tenants.
 */
import React from 'react';

// Cerebro Core Logo - Teal/Gold Neural Brain Hexagon
const CEREBRO_LOGO = "https://customer-assets.emergentagent.com/job_cpd-compass/artifacts/km6w43n1_Teal%20Cerebro%20Transp.png";

/**
 * Footer badge version - subtle placement in page footer
 */
export function PoweredByCerebroFooter({ className = '' }) {
  return (
    <div 
      className={`flex items-center justify-center gap-2 py-4 text-zinc-500 ${className}`}
      data-testid="powered-by-cerebro-footer"
    >
      <span className="text-xs">Powered by</span>
      <a 
        href="https://cerebro.co.za" 
        target="_blank" 
        rel="noopener noreferrer"
        className="flex items-center gap-1.5 hover:opacity-80 transition-opacity"
      >
        <img 
          src={CEREBRO_LOGO} 
          alt="Cerebro Core" 
          className="h-5 w-5"
        />
        <span className="text-xs font-semibold text-zinc-400">Cerebro Core</span>
      </a>
    </div>
  );
}

/**
 * Login page badge version - more prominent placement
 */
export function PoweredByCerebroBadge({ className = '' }) {
  return (
    <div 
      className={`inline-flex items-center gap-2 px-3 py-1.5 bg-zinc-900/50 border border-zinc-700/50 rounded-full backdrop-blur-sm ${className}`}
      data-testid="powered-by-cerebro-badge"
    >
      <span className="text-xs text-zinc-400">Powered by</span>
      <a 
        href="https://cerebro.co.za" 
        target="_blank" 
        rel="noopener noreferrer"
        className="flex items-center gap-1.5 hover:opacity-80 transition-opacity"
      >
        <img 
          src={CEREBRO_LOGO} 
          alt="Cerebro Core" 
          className="h-4 w-4"
        />
        <span className="text-xs font-semibold text-navigate-gold">Cerebro Core</span>
      </a>
    </div>
  );
}

/**
 * Compact inline version for tight spaces
 */
export function PoweredByCerebroInline({ className = '' }) {
  return (
    <a 
      href="https://cerebro.co.za" 
      target="_blank" 
      rel="noopener noreferrer"
      className={`inline-flex items-center gap-1 text-xs text-zinc-500 hover:text-zinc-400 transition-colors ${className}`}
      data-testid="powered-by-cerebro-inline"
    >
      <span>Powered by</span>
      <img 
        src={CEREBRO_LOGO} 
        alt="Cerebro Core" 
        className="h-3.5 w-3.5"
      />
      <span className="font-medium">Cerebro Core</span>
    </a>
  );
}

export default PoweredByCerebroFooter;
